import { Injectable } from '@angular/core';
import { CommonService } from 'src/app/shared/utils/common.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { indicadoresVivosModulo } from '../diccionarios/indicadoresVivosModulo';

@Injectable({
  providedIn: 'root'
})
export class DireccionesUsuariosService {

  diccionarioUrl: any;
  urlDistribuidor: string;
  urlPresupuestoComercial: string;
  constructor(
    private commom: CommonService,
    private utilServices: UtilsService
  ){
    this.urlDistribuidor = this.utilServices.getDistribuidor();
    this.urlPresupuestoComercial = this.utilServices.getPresupuestoComercial();
    this.diccionarioUrl = indicadoresVivosModulo.url.indicadores;
  }

  getDireccionesUsuarios() {
    return this.commom.peticionGetConHeader(this.urlPresupuestoComercial + this.diccionarioUrl.usuarioDirecciones);
  }

  getUsuarios(innUsuarios: string) {
    return this.commom.peticionGetConHeader(this.urlPresupuestoComercial + this.diccionarioUrl.usuarioDirecciones + `/${innUsuarios}`);
  }

  saveDireccionesUsuarios(innObj: any) {
    return this.commom.peticionPostConHeader(this.urlPresupuestoComercial + this.diccionarioUrl.usuarioDirecciones, innObj);
  }

  deleteDireccionesUsuarios(pkusuario: string, pkDireccion: string) {
    return this.commom.peticionDeleteConHeader(this.urlPresupuestoComercial + this.diccionarioUrl.usuarioDirecciones + `/${pkusuario}/${pkDireccion}`);
  }
  
}
